<div style="height: 100vh; position: relative;">
	<div style="position: absolute; top: calc(45vh - 32px); left: calc(50vw - 32px);">
		<div class="page-loading-spinner"></div>
	</div>
</div>